
import * as $ from 'jquery';

import * as EditorLocator from 'src/shared/tinymce/EditorLocator';

/**
 * Remove HTML elements that match the given CSS selector when a rich paste takes place in a TinyMCE v4 editor.
 *
 * This has been verified against TinyMCE v4.8.5.
 *
 * @param {String|Regex}    editorId           The id of the TinyMCE editor to bind to. See `EditorLocator` for more
 *                                             info
 * @param {String}          removalSelector    The CSS selector that matches those elements that should be filtered
 *                                             out of the pasted rich text.
 */
export function fix(editorId, removalSelector) {
    EditorLocator.locate(editorId).then(function(editor) {
        editor.on('PastePreProcess', function(event) {
            if (event && event.content) {
                var $content = $('<div />').append(event.content);
                if ($content.find(removalSelector).length > 0) {
                    $content.find(removalSelector).remove();
                    event.content = $content.html();
                }
            }
        });
    });
}
